import * as React from 'react';
import classnames from '../../../utils/classnames.tsx';
import { useLayoutContext } from '../../../contexts/LayoutContext.tsx';
import PageHeaderNavigationToggle from './PageHeaderNavigationToggle.tsx';

// SecondaryNavigation renders into this slot on small screens so it sits directly below the page header
const PageSubHeaderSlot = () => {
    const layout = useLayoutContext();
    if (!layout) return null;
    return <div ref={layout.setSubHeaderSlot} className="md:hidden flex-none" />;
};

interface HeaderProps {
    className?: string;
    children?: React.ReactNode;
    // the first header of a page renders the mobile navigation toggle and hosts the secondary navigation slot;
    // pages that stack a second header (filter bars, tab rows) pass `primary={false}`
    primary?: boolean;
}

const PageHeader = ({ className, children, primary = true }: HeaderProps) => {
    const layout = useLayoutContext();
    const showToggle = primary && !!layout?.openNavigation;

    return (
        <>
            <header
                className={classnames(
                    'relative w-full h-14 px-4 md:px-7 py-2 flex-none flex items-center max-md:gap-3 overflow-x-auto whitespace-nowrap *:shrink-0 bg-surface-weak border-solid border-b border-line-weak',
                    showToggle && 'max-md:pl-14',
                    className
                )}
            >
                {/* positioned instead of laid out so consumer layouts such as `justify-between` stay untouched */}
                {showToggle && <PageHeaderNavigationToggle className="absolute left-4 top-1/2 -translate-y-1/2" />}
                {children}
            </header>
            {primary && <PageSubHeaderSlot />}
        </>
    );
};

export default PageHeader;
